/**
 * frontend/src/hooks/useSearch.js
 *
 * All search state and async logic.
 * Components call this hook — they have no knowledge of the API service.
 */

import { useState, useCallback } from 'react';
import ApiService from '../services/ApiService';
import SettingsStore from '../store/SettingsStore';

export function useSearch() {
    const [results, setResults] = useState([]);
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [query, setQuery] = useState('');


    const search = useCallback(async (params) => {
        // Merge with user's default settings from store
        const defaultParams = SettingsStore.getSearchParams();
        const merged = { ...defaultParams, ...params };

        setQuery(merged.query || '');
        setLoading(true);
        setError(null);

        try {
            const response = await ApiService.search(merged);
            setResults(response.results);
            setMeta(response.meta);
        } catch (err) {
            setError(err.message || 'Search failed. Please try again.');
            setResults([]);
            setMeta(null);
        } finally {
            setLoading(false);
        }
    }, []);

    const clear = useCallback(() => {
        setResults([]);
        setMeta(null);
        setError(null);
        setQuery('');
    }, []);

    return {
        results,
        meta,
        loading,
        error,
        query,
        search,
        clear,
        hasResults: results.length > 0,
    };
}
